import {Pipe, PipeTransform} from '@angular/core';

import {DataAttribute, GroupedDataAttribute} from '../../../views/admin/application-settings/models/data-attribute.model';
import {ApplicationsService} from '../../../views/admin/provider/applications/applications.service';

@Pipe({
    name: 'ngcGetAvailableFilteredMappingAttributes'
})
export class NgcGetAvailableFilteredMappingAttributesPipe implements PipeTransform {

    constructor(private applicationsService: ApplicationsService) { }

    transform(
        attributeList: DataAttribute[],
        attributesByType: GroupedDataAttribute,
        selectedProperty: DataAttribute,
        filtredValue: string = ''
    ): DataAttribute[] {
        return this.applicationsService.getAvailableFiltredMappingAttributes(
            attributeList,
            attributesByType,
            selectedProperty,
            filtredValue
        );
    }
}
